export const sbpValidator = {
    bank: {
        required: 'Банк является обязательным полем',
    },
    phone: {
        required: 'Телефон является обязательным полем',
        pattern: {
            value: /^[0-9]{11}$/,
            message: 'Введите номер в формате +7 (ххх) ххх хх хх',
        },
    },
}
